import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import ErrorMessage from "./ErrorMessage.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormControl',
    props: {
        required: Boolean,
        error: String,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["form-group", { 'form-group--required': __props.required, 'has-error': __props.error }])
            }, [
                _renderSlot(_ctx.$slots, "default"),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (__props.error)
                    ? (_openBlock(), _createBlock(ErrorMessage, {
                        key: 0,
                        error: __props.error
                    }, null, 8 /* PROPS */, ["error"]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
